// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IEmploymentStatusDto } from './IEmploymentStatusDto';
import {
    IEmploymentStatusDtoFromJSON,
    IEmploymentStatusDtoFromJSONTyped,
    IEmploymentStatusDtoToJSON,
    IEmploymentStatusDtoToJSONTyped,
} from './IEmploymentStatusDto';
import type { IUserCommunicationConfigurationInfoDto } from './IUserCommunicationConfigurationInfoDto';
import {
    IUserCommunicationConfigurationInfoDtoFromJSON,
    IUserCommunicationConfigurationInfoDtoFromJSONTyped,
    IUserCommunicationConfigurationInfoDtoToJSON,
    IUserCommunicationConfigurationInfoDtoToJSONTyped,
} from './IUserCommunicationConfigurationInfoDto';
import type { IParticipantAddressInfoDto } from './IParticipantAddressInfoDto';
import {
    IParticipantAddressInfoDtoFromJSON,
    IParticipantAddressInfoDtoFromJSONTyped,
    IParticipantAddressInfoDtoToJSON,
    IParticipantAddressInfoDtoToJSONTyped,
} from './IParticipantAddressInfoDto';

/**
 * 
 * @export
 * @interface IEmployeeInfoResponseDto
 */
export interface IEmployeeInfoResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoResponseDto
     */
    person_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    full_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoResponseDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    employer_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoResponseDto
     */
    is_employee_email_preferred?: boolean;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoResponseDto
     */
    phone1?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IEmployeeInfoResponseDto
     */
    phone2?: IPhoneInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    home_phone_number?: string;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoResponseDto
     */
    mailing_address?: IParticipantAddressInfoDto;
    /**
     * 
     * @type {IParticipantAddressInfoDto}
     * @memberof IEmployeeInfoResponseDto
     */
    physical_address?: IParticipantAddressInfoDto;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoResponseDto
     */
    use_same_address_for_mailing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    status?: IEmployeeInfoResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<IEmploymentStatusDto>}
     * @memberof IEmployeeInfoResponseDto
     */
    employment_statuses?: Array<IEmploymentStatusDto>;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoResponseDto
     */
    employment_status_effective_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoResponseDto
     */
    hire_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    user_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeInfoResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    organization_id_source_type?: IEmployeeInfoResponseDtoOrganizationIdSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {IUserCommunicationConfigurationInfoDto}
     * @memberof IEmployeeInfoResponseDto
     */
    user_communication_configuration?: IUserCommunicationConfigurationInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    claim_autopay_type?: IEmployeeInfoResponseDtoClaimAutopayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    default_claim_payee_type?: IEmployeeInfoResponseDtoDefaultClaimPayeeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    payroll_group_code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoResponseDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    custom_field1?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    custom_field2?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    custom_field3?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    custom_field4?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    custom_field5?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoResponseDto
     */
    is_employee_email_verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoResponseDto
     */
    is_employer_email_verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoResponseDto
     */
    is_created_by_orphan?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeInfoResponseDto
     */
    mfa_locked_to?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeInfoResponseDto
     */
    required_participant_mfa?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeInfoResponseDto
     */
    gender?: IEmployeeInfoResponseDtoGenderEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoResponseDtoStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoResponseDtoOrganizationIdSourceTypeEnum {
    SSN = 'SSN',
    EMPLOYER_EMPLOYEE_ID = 'EMPLOYER_EMPLOYEE_ID',
    PARTNER_EMPLOYEE_ID = 'PARTNER_EMPLOYEE_ID'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoResponseDtoClaimAutopayTypeEnum {
    AUTO = 'AUTO',
    CLICK = 'CLICK'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoResponseDtoDefaultClaimPayeeTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    EMPLOYEE_CHOICE = 'EMPLOYEE_CHOICE'
}
/**
* @export
* @enum {string}
*/
export enum IEmployeeInfoResponseDtoGenderEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}


/**
 * Check if a given object implements the IEmployeeInfoResponseDto interface.
 */
export function instanceOfIEmployeeInfoResponseDto(value: object): value is IEmployeeInfoResponseDto {
    return true;
}

export function IEmployeeInfoResponseDtoFromJSON(json: any): IEmployeeInfoResponseDto {
    return IEmployeeInfoResponseDtoFromJSONTyped(json, false);
}

export function IEmployeeInfoResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeInfoResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'full_name': json['full_name'] == null ? undefined : json['full_name'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'employer_provided_email': json['employer_provided_email'] == null ? undefined : json['employer_provided_email'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'is_employee_email_preferred': json['is_employee_email_preferred'] == null ? undefined : json['is_employee_email_preferred'],
        'phone1': json['phone1'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone1']),
        'phone2': json['phone2'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone2']),
        'home_phone_number': json['home_phone_number'] == null ? undefined : json['home_phone_number'],
        'mailing_address': json['mailing_address'] == null ? undefined : IParticipantAddressInfoDtoFromJSON(json['mailing_address']),
        'physical_address': json['physical_address'] == null ? undefined : IParticipantAddressInfoDtoFromJSON(json['physical_address']),
        'use_same_address_for_mailing': json['use_same_address_for_mailing'] == null ? undefined : json['use_same_address_for_mailing'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'employment_statuses': json['employment_statuses'] == null ? undefined : ((json['employment_statuses'] as Array<any>).map(IEmploymentStatusDtoFromJSON)),
        'employment_status_effective_on': json['employment_status_effective_on'] == null ? undefined : (new Date(json['employment_status_effective_on'])),
        'hire_on': json['hire_on'] == null ? undefined : (new Date(json['hire_on'])),
        'user_name': json['user_name'] == null ? undefined : json['user_name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'organization_id_source_type': json['organization_id_source_type'] == null ? undefined : json['organization_id_source_type'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'user_communication_configuration': json['user_communication_configuration'] == null ? undefined : IUserCommunicationConfigurationInfoDtoFromJSON(json['user_communication_configuration']),
        'claim_autopay_type': json['claim_autopay_type'] == null ? undefined : json['claim_autopay_type'],
        'default_claim_payee_type': json['default_claim_payee_type'] == null ? undefined : json['default_claim_payee_type'],
        'payroll_group_code': json['payroll_group_code'] == null ? undefined : json['payroll_group_code'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'custom_field1': json['custom_field1'] == null ? undefined : json['custom_field1'],
        'custom_field2': json['custom_field2'] == null ? undefined : json['custom_field2'],
        'custom_field3': json['custom_field3'] == null ? undefined : json['custom_field3'],
        'custom_field4': json['custom_field4'] == null ? undefined : json['custom_field4'],
        'custom_field5': json['custom_field5'] == null ? undefined : json['custom_field5'],
        'is_employee_email_verified': json['is_employee_email_verified'] == null ? undefined : json['is_employee_email_verified'],
        'is_employer_email_verified': json['is_employer_email_verified'] == null ? undefined : json['is_employer_email_verified'],
        'is_created_by_orphan': json['is_created_by_orphan'] == null ? undefined : json['is_created_by_orphan'],
        'mfa_locked_to': json['mfa_locked_to'] == null ? undefined : (new Date(json['mfa_locked_to'])),
        'required_participant_mfa': json['required_participant_mfa'] == null ? undefined : json['required_participant_mfa'],
        'gender': json['gender'] == null ? undefined : json['gender'],
    };
}

export function IEmployeeInfoResponseDtoToJSON(json: any): IEmployeeInfoResponseDto {
    return IEmployeeInfoResponseDtoToJSONTyped(json, false);
}

export function IEmployeeInfoResponseDtoToJSONTyped(value?: IEmployeeInfoResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person_id': value['person_id'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'full_name': value['full_name'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'ssn': value['ssn'],
        'employer_provided_email': value['employer_provided_email'],
        'employee_provided_email': value['employee_provided_email'],
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'phone1': IPhoneInfoDtoToJSON(value['phone1']),
        'phone2': IPhoneInfoDtoToJSON(value['phone2']),
        'home_phone_number': value['home_phone_number'],
        'mailing_address': IParticipantAddressInfoDtoToJSON(value['mailing_address']),
        'physical_address': IParticipantAddressInfoDtoToJSON(value['physical_address']),
        'use_same_address_for_mailing': value['use_same_address_for_mailing'],
        'employer_name': value['employer_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'employee_id': value['employee_id'],
        'status': value['status'],
        'employment_statuses': value['employment_statuses'] == null ? undefined : ((value['employment_statuses'] as Array<any>).map(IEmploymentStatusDtoToJSON)),
        'employment_status_effective_on': value['employment_status_effective_on'] == null ? undefined : ((value['employment_status_effective_on']).toISOString().substring(0,10)),
        'hire_on': value['hire_on'] == null ? undefined : ((value['hire_on']).toISOString().substring(0,10)),
        'user_name': value['user_name'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'organization_id_source_type': value['organization_id_source_type'],
        'organization_path': value['organization_path'],
        'user_communication_configuration': IUserCommunicationConfigurationInfoDtoToJSON(value['user_communication_configuration']),
        'claim_autopay_type': value['claim_autopay_type'],
        'default_claim_payee_type': value['default_claim_payee_type'],
        'payroll_group_code': value['payroll_group_code'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'custom_field1': value['custom_field1'],
        'custom_field2': value['custom_field2'],
        'custom_field3': value['custom_field3'],
        'custom_field4': value['custom_field4'],
        'custom_field5': value['custom_field5'],
        'is_employee_email_verified': value['is_employee_email_verified'],
        'is_employer_email_verified': value['is_employer_email_verified'],
        'is_created_by_orphan': value['is_created_by_orphan'],
        'mfa_locked_to': value['mfa_locked_to'] == null ? undefined : ((value['mfa_locked_to']).toISOString()),
        'required_participant_mfa': value['required_participant_mfa'],
        'gender': value['gender'],
    };
}

